const productSubscriptions = class extends HTMLElement {
  constructor() {
    super()

    this.form = this.closest('form')
    this.sellingPlanInput = this.querySelector('[data-selling-plan-input]')
    this.variantSellingPlanGroupings = this.querySelectorAll('[data-selling-plan-variant-grouping]')
    this.variantIdInput = this.form.querySelector('input[name="id"]')
    this.sellingPlanOptionWrappers = this.querySelectorAll('[data-selling-plan-wrapper]')
    this.sellingPlanOptions = this.querySelectorAll('[data-selling-plan]')
    this.sellingPlanTypeLabel = this.querySelector('[data-selling-plan-type]')
    if (this.sellingPlanOptions.length || this.hasSubscribeIntervalUi()) {
      this.init()
    }
  }

  hasSubscribeIntervalUi () {
    return Boolean(this.form?.closest('.product-info')?.querySelector('variant-picker .subscribe-interval-cards'))
  }

  init () {
    this.sellingPlanOptions.forEach(sellingPlanOption => {
      sellingPlanOption.addEventListener('change', () => {
        this.sellingPlanInput.value = sellingPlanOption.value
        this.sellingPlanTypeLabel.innerHTML = sellingPlanOption.dataset.frequency
        this.sellingPlanInput.name = sellingPlanOption.value ? 'selling_plan' : ''
        this.variantIdInput.value = sellingPlanOption.dataset.variantId

        this.sellingPlanOptionWrappers.forEach(sellingPlanOptionWrapper => {
          sellingPlanOptionWrapper.classList.toggle('active', sellingPlanOptionWrapper.contains(sellingPlanOption))
        })
      })
    })

    this.variantIdInput.addEventListener('change', (event) => {
      if (this.hasSubscribeIntervalUi()) {
        this.syncSellingPlanFromVariantMap()
      } else {
        this.variantChanged(event.target.value)
      }
    })

    // Listen for variant:change event to update one-time purchase price
    this.form.addEventListener('variant:change', (event) => {
      if (this.hasSubscribeIntervalUi()) {
        this.syncSellingPlanFromVariantMap()
      }
      this.updateOneTimePrice(event.detail.variant)
    })

    // Initialize one-time purchase price on load
    this.initializeOneTimePrice();

    // Make the entire subscription option clickable
    this.sellingPlanOptionWrappers.forEach(sellingPlanOptionWrapper => {
      const list = sellingPlanOptionWrapper.querySelector('[data-selling-plan-details]')
      if (!list) { return }
      list.style.setProperty('--list-height', `${list.scrollHeight}px`);
      
      // Add click handler to the data-selling-plan-wrapper element
      sellingPlanOptionWrapper.addEventListener('click', (event) => {
        // Don't trigger if clicking directly on the radio button (to avoid double-triggering)
        if (event.target.type === 'radio') {
          return
        }
        
        // Find the radio button within this wrapper and click it
        const radioButton = sellingPlanOptionWrapper.querySelector('input[type="radio"]')
        if (radioButton) {
          radioButton.click()
        }
      })
    })

    // One-time purchase as link below button: set selling plan to empty and submit
    const oneTimeLink = this.form.querySelector('[data-one-time-purchase-link]')
    if (oneTimeLink && this.sellingPlanInput) {
      oneTimeLink.addEventListener('click', (event) => {
        event.preventDefault()
        if (this.form.dataset.ordersPaused === 'true') return
        this.applySellingPlanValue('')
        const oneTimeInput = this.querySelector('[data-subscription-type="one-time"] input[data-selling-plan]')
        if (oneTimeInput && !oneTimeInput.checked) {
          oneTimeInput.click()
        }
        this.submitOneTimeCheckout(oneTimeLink)
      })
    }

    if (this.hasSubscribeIntervalUi()) {
      this.syncSellingPlanFromVariantMap()
    }
  }

  applySellingPlanValue (planId) {
    const formId = this.form?.getAttribute?.('id')
    const isDoseModalSellingPlan = (input) =>
      Boolean(input.closest('dose-finder-modal') || input.hasAttribute('data-dose-selling-plan-input'))

    let inputs = formId
      ? Array.from(document.querySelectorAll(`input[name="selling_plan"][form="${formId}"]`))
      : []
    inputs = inputs.filter((input) => !isDoseModalSellingPlan(input))
    if (!inputs.length) {
      inputs = Array.from(this.form.querySelectorAll('input[name="selling_plan"]'))
      inputs = inputs.filter((input) => !isDoseModalSellingPlan(input))
    }
    if (!inputs.length && this.form) {
      const root = this.form.closest('.product-info--subscribe-ui') || this.form.closest('.product-info')
      if (root) {
        inputs = Array.from(root.querySelectorAll('input[name="selling_plan"]'))
        inputs = inputs.filter((input) => !isDoseModalSellingPlan(input))
      }
    }
    if (inputs.length) {
      inputs.forEach((inp) => {
        inp.value = planId || ''
        inp.name = planId ? 'selling_plan' : ''
      })
    } else if (this.sellingPlanInput && !isDoseModalSellingPlan(this.sellingPlanInput)) {
      this.sellingPlanInput.value = planId || ''
      this.sellingPlanInput.name = planId ? 'selling_plan' : ''
    }
    if (this.sellingPlanTypeLabel && planId && formId) {
      const checked = document.querySelector(
        `.subscribe-interval-cards input[type="radio"][form="${formId}"]:checked`
      )
      if (checked) {
        const title = checked.closest('.subscribe-interval-cards__item')?.querySelector('.subscribe-card__title')
        if (title) this.sellingPlanTypeLabel.textContent = title.textContent.trim()
      }
    }
  }

  syncSellingPlanFromVariantMap () {
    if (!this.sellingPlanInput) return
    const variantId = parseInt(this.variantIdInput?.value, 10)
    const formId = this.form?.getAttribute?.('id')

    // Subscribe interval rows carry the correct selling plan per format+interval (not always "first" allocation).
    if (this.hasSubscribeIntervalUi() && formId) {
      const checked = document.querySelector(
        `.subscribe-interval-cards input[type="radio"][form="${formId}"]:checked:not(:disabled)`
      )
      if (checked) {
        const planId = checked.getAttribute('data-selling-plan-id')
        if (planId) {
          this.applySellingPlanValue(planId)
          return
        }
      }
    }

    const mapEl = document.querySelector('script[data-variant-selling-plan-ids]')
    if (mapEl && variantId) {
      try {
        const map = JSON.parse(mapEl.textContent)
        const planId = map[variantId] != null && map[variantId] !== null ? String(map[variantId]) : ''
        if (planId) {
          this.applySellingPlanValue(planId)
          return
        }
      } catch (e) {
        /* ignore */
      }
    }

    if (formId) {
      const checked = document.querySelector(
        `.subscribe-interval-cards input[type="radio"][form="${formId}"]:checked:not(:disabled)`
      )
      if (checked) {
        const planId = checked.getAttribute('data-selling-plan-id')
        if (planId) this.applySellingPlanValue(planId)
      }
    }
  }

  variantChanged (variantId) {
    this.variantSellingPlanGroupings.forEach(variantSellingPlanGrouping => {
      if(variantSellingPlanGrouping.dataset.variantId == variantId) {
        variantSellingPlanGrouping.classList.add('is-active');
        // Click the first subscription option for this variant to update prices
        const firstOption = variantSellingPlanGrouping.querySelector('[data-selling-plan]');
        if (firstOption) {
          firstOption.click();
        }
      } else {
        variantSellingPlanGrouping.classList.remove('is-active');
      }
    });
  }

  initializeOneTimePrice () {
    // Wait a bit for variant picker to initialize, then get initial variant
    setTimeout(() => {
      const variantId = this.variantIdInput?.value;
      if (!variantId) return;

      // Try to get variant from variant:change event if it fires
      const checkVariant = () => {
        // Check if variant picker is available and has product data
        const variantPicker = document.querySelector('variant-picker[form="' + this.form.getAttribute('id') + '"]');
        if (variantPicker && variantPicker.product) {
          const variant = variantPicker.product.variants.find(v => v.id === parseInt(variantId));
          if (variant) {
            this.updateOneTimePrice(variant);
            return;
          }
        }

        // Fallback: try to get variant data from the form's data attributes or wait for variant:change
        // If variant:change hasn't fired yet, wait a bit more
        setTimeout(() => {
          if (!this._oneTimePriceInitialized) {
            // Try one more time after a delay
            const variantPicker = document.querySelector('variant-picker[form="' + this.form.getAttribute('id') + '"]');
            if (variantPicker && variantPicker.product) {
              const variant = variantPicker.product.variants.find(v => v.id === parseInt(variantId));
              if (variant) {
                this.updateOneTimePrice(variant);
                this._oneTimePriceInitialized = true;
              }
            }
          }
        }, 500);
      };

      checkVariant();
    }, 100);
  }

  updateOneTimePrice (variant) {
    if (!variant) return;

    this._oneTimePriceInitialized = true;

    const oneTimePriceElement = this.querySelector('[data-one-time-price]');
    const oneTimeComparePriceElement = this.querySelector('[data-one-time-compare-price]');
    const oneTimeInput = this.querySelector('[data-subscription-type="one-time"] input[data-selling-plan]');
    const oneTimeServingWrapper = this.querySelector('[data-one-time-serving-wrapper]');
    const oneTimeServingComparePrice = this.querySelector('[data-one-time-serving-compare-price]');
    const oneTimeServingFinalPrice = this.querySelector('[data-one-time-serving-final-price]');

    const moneyWithCurrencyFormat =
      typeof window.themeVariables !== 'undefined' && window.themeVariables.settings?.moneyWithCurrencyFormat
        ? window.themeVariables.settings.moneyWithCurrencyFormat
        : '';
    const formatPrice = (cents) => {
      if (typeof formatMoney === 'function') {
        return moneyWithCurrencyFormat ? formatMoney(cents, moneyWithCurrencyFormat) : formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    };

    let marketOneTime = null;
    const oneTimeMoneyScript = this.querySelector('[data-variant-one-time-money]');
    if (oneTimeMoneyScript) {
      try {
        const byId = JSON.parse(oneTimeMoneyScript.textContent);
        marketOneTime = byId[variant.id != null ? String(variant.id) : ''] || null;
      } catch (e) {
        /* ignore */
      }
    }

    const oneTimeDisplay = marketOneTime && marketOneTime.price ? marketOneTime.price : formatPrice(variant.price);

    if (oneTimePriceElement) {
      oneTimePriceElement.textContent = oneTimeDisplay;
    }

    // Update one-time purchase link below button (when one-time is shown as link)
    const oneTimeLinkPrice = this.form.querySelector('[data-one-time-purchase-link] [data-one-time-price]');
    if (oneTimeLinkPrice) {
      oneTimeLinkPrice.textContent = oneTimeDisplay;
    }

    if (oneTimeComparePriceElement) {
      if (marketOneTime && marketOneTime.compare) {
        oneTimeComparePriceElement.textContent = marketOneTime.compare;
        oneTimeComparePriceElement.style.display = '';
      } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        oneTimeComparePriceElement.textContent = formatPrice(variant.compare_at_price);
        oneTimeComparePriceElement.style.display = '';
      } else {
        oneTimeComparePriceElement.style.display = 'none';
      }
    }

    // Update serving price if data is available
    const oneTimePriceContainer = this.querySelector('[data-subscription-type="one-time"] .product-subscriptions__subscription-price-container');
    if (oneTimePriceContainer) {
      // Get price_per_serving data from the JSON script tag
      const pricePerServingScript = this.querySelector('[data-variant-price-per-serving]');
      if (pricePerServingScript) {
        try {
          const variantPricePerServing = JSON.parse(pricePerServingScript.textContent);
          const pricePerServing = variantPricePerServing[variant.id.toString()];
          
          // Remove existing wrapper if it exists
          const existingWrapper = oneTimePriceContainer.querySelector('[data-one-time-serving-wrapper]');
          if (existingWrapper) {
            existingWrapper.remove();
          }
          
          // Add wrapper if variant has price_per_serving data
          if (pricePerServing) {
            const wrapper = document.createElement('p');
            wrapper.className = 'product-subscriptions__subscription-price-wrapper';
            wrapper.setAttribute('data-one-time-serving-wrapper', '');
            
            // Add final price (price_per_serving is already in cents)
            const finalPrice = document.createElement('span');
            finalPrice.className = 'product-subscriptions__subscription-serve-price';
            finalPrice.setAttribute('data-one-time-serving-final-price', '');
            finalPrice.textContent = formatPrice(pricePerServing);
            wrapper.appendChild(finalPrice);
            
            // Add label - get from existing subscription options or use fallback
            const existingLabel = this.querySelector('.product-subscriptions__subscription-price-label');
            const label = document.createElement('span');
            label.className = 'product-subscriptions__subscription-price-label';
            label.textContent = existingLabel ? existingLabel.textContent : 'per serving';
            wrapper.appendChild(label);
            
            // Append to container
            oneTimePriceContainer.appendChild(wrapper);
          }
        } catch (e) {
          console.error('Error parsing price_per_serving data:', e);
        }
      }
    }

    // Update the data-variant-id on the one-time purchase input
    if (oneTimeInput) {
      oneTimeInput.setAttribute('data-variant-id', variant.id);
    }
  }

  async submitOneTimeCheckout (triggerEl) {
    if (!this.form || this.form.dataset.ordersPaused === 'true') return
    const prevLabel = triggerEl ? triggerEl.textContent : ''
    if (triggerEl) {
      triggerEl.setAttribute('aria-busy', 'true')
      triggerEl.setAttribute('disabled', 'disabled')
      triggerEl.textContent = 'Loading...'
    }

    const stalePropertyNames = [
      'properties[Discount]',
      'properties[_skio_selling_plan_group]',
      'properties[shipping_interval_frequency]',
      'properties[shipping_interval_unit_type]',
    ]
    const disabledEls = []

    try {
      if (typeof window.nativeCartSubmitProductForm === 'function') {
        for (const el of this.form.elements) {
          if (stalePropertyNames.includes(el.name) && !el.disabled) {
            el.disabled = true
            disabledEls.push(el)
          }
        }
        await window.nativeCartSubmitProductForm(this.form)
      } else {
        const formData = new window.FormData(this.form)
        formData.delete('selling_plan')
        // Strip any Skio / subscription line-item properties that may still
        // be sitting on the form (e.g. from Skio's own plan-picker block).
        // Otherwise a one-time purchase ends up with stale subscription
        // properties — Rebuy then renders a misleading "Discount : 25%"
        // label even though no discount is actually applied.
        formData.delete('properties[Discount]')
        formData.delete('properties[_skio_selling_plan_group]')
        formData.delete('properties[shipping_interval_frequency]')
        formData.delete('properties[shipping_interval_unit_type]')
        const res = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        if (!res.ok) throw new Error('add.js failed')
        const responseJson = await res.json()
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json()
        this.form.dispatchEvent(new CustomEvent('variant:add', {
          bubbles: true,
          detail: {
            items: responseJson.hasOwnProperty('items') ? responseJson.items : [responseJson],
            cart: cartContent
          }
        }))
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            cart: cartContent
          }
        }))
      }
    } catch (e) {
      // Fallback to native submit path if AJAX fails.
      this.form.submit()
    } finally {
      disabledEls.forEach((el) => { el.disabled = false })
      if (triggerEl) {
        triggerEl.removeAttribute('aria-busy')
        triggerEl.removeAttribute('disabled')
        if (prevLabel) triggerEl.textContent = prevLabel
      }
    }
  }
}

if (typeof window.customElements.get('product-subscriptions') === 'undefined') {
  window.customElements.define('product-subscriptions', productSubscriptions)
}
